var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildModalHeaderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5419_7510)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 2,
    width: 32,
    height: 32,
    rx: 3.47841,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2.5,
    width: 31,
    height: 31,
    rx: 2.97841,
    stroke: "url(#paint0_linear_5419_7510)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5419_7510)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 8.00009C21.5 7.54832 21.1971 7.15265 20.761 7.03475C20.3249 6.91684 19.8639 7.10599 19.6362 7.49622L12.6362 19.4962C12.4558 19.8055 12.4545 20.1877 12.6329 20.4982C12.8112 20.8086 13.1419 21.0001 13.5 21.0001H17.5V28.0001C17.5 28.4519 17.8029 28.8475 18.239 28.9654C18.6751 29.0833 19.1361 28.8942 19.3638 28.504L26.3638 16.504C26.5442 16.1947 26.5455 15.8125 26.3671 15.502C26.1888 15.1915 25.8581 15.0001 25.5 15.0001H21.5V8.00009Z",
    fill: "url(#paint1_linear_5419_7510)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5419_7510",
    x: 0.891195,
    y: 0.260796,
    width: 37.2176,
    height: 37.2176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.869602
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3044
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5419_7510"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5419_7510",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5419_7510",
    x1: 3.95977,
    y1: 28.0945,
    x2: 35.5,
    y2: 28.0945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5419_7510",
    x1: 12.7011,
    y1: 24.9401,
    x2: 26.5,
    y2: 24.9401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C4ACF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69B7FA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_7510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(7.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildModalHeaderIcon);
export default __webpack_public_path__ + "static/media/BuildModalHeaderIcon.305d55997033f5e6ad1b7e0f8bbfcd65.svg";
export { ForwardRef as ReactComponent };